import { ErrorBoundary } from '@sentry/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { FirebaseUserProvider } from './auth/FirebaseUserProvider.tsx'
import { L10NProvider } from './l10n/l10nProvider.tsx'
import { SentryErrorPage } from './pages/error/SentryErrorPage.tsx'
import { isSupportEmbed } from './pages/support/embed/piloteFrame.ts'
import { SupportEmbedUnavailable } from './pages/support/embed/SupportEmbedPage.tsx'
import { AppRouter } from './AppRouter.tsx'
import { initFirebase } from './firebase.ts'

initFirebase()

const queryClient = new QueryClient()

const supportEmbedFallback = isSupportEmbed() ? <SupportEmbedUnavailable /> : undefined

export const App = () => (
  <ErrorBoundary fallback={SentryErrorPage}>
    <QueryClientProvider client={queryClient}>
      <L10NProvider>
        <FirebaseUserProvider supportEmbedFallback={supportEmbedFallback}>
          <AppRouter />
        </FirebaseUserProvider>
      </L10NProvider>
    </QueryClientProvider>
  </ErrorBoundary>
)
